import axios from "axios";
/**
 * Updates the quotes assigned to requests in a PX request
 */
export async function updateQuotes(pxRequestId, quotes) {
  const quotesData = Object.keys(quotes).reduce((acc, key) => ({
    ...acc,
    [key]: quotes[key].id,
  }), {});

  return axios.put(`/api/px-requests/${pxRequestId}/quotes`, { quotes: quotesData });
}

